import {mergeToHierarchy} from '#core/utils/config-utils.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {EventPage} from '../event-page.js';

import {marketsFactory} from './markets.factory';

import PALETTE_SCHEMA from './markets.palette-schema.yaml';
import SCHEMA from './markets.schema.yaml';

class MarketsFeature extends AbstractVisualFeature {
    get name() {
        return 'Markets';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getVisualConfig(PALETTE) {
        return marketsFactory(PALETTE);
    }

    beforeMojitoConfigBuild(mojitoConfig) {
        const responsiveSelections = this.config.enableResponsiveSelections
            ? {
                  genericMarketContent: {
                      market: {
                          direction: 'auto',
                          selectionLayoutOverrides: {
                              column: 'horizontalAlignLeft',
                          },
                      },
                  },
              }
            : {};

        mergeToHierarchy(mojitoConfig, 'services.configurations', {
            GenericMarketContent: {
                rowsThreshold: this.config.rowsThreshold,
                numberOfExpandedRows: this.config.numberOfExpandedRows,
                market: {
                    selectionButton: {
                        view: {
                            infoText: {
                                ellipsisOnLineNumber: this.config.ellipsisOnLineNumber,
                            },
                        },
                    },
                },
                layoutDescriptors: {
                    types: (this.config.withHiddenHeaders || []).reduce((acc, marketType) => {
                        acc[marketType] = {selectionsHeaderContent: 'undefined'};
                        return acc;
                    }, {}),
                },
            },
            EventPage: {
                eventMarkets: {
                    ...responsiveSelections,
                },
            },
        });

        return super.beforeMojitoConfigBuild(mojitoConfig);
    }
}

new MarketsFeature(EventPage);
